// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__Yet5m","about":"Footer_about__34oi0"};